import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { Control, Controller } from "react-hook-form";

import { colors } from "src/colors";

import { OFText } from "../OFText";
import { OFInput } from "./OFInput";

const validate = (evt) => {
  const e = evt || window.event;
  const key = e.keyCode || e.which;

  if (
    (!e.shiftKey &&
      !e.altKey &&
      !e.ctrlKey &&
      // numbers
      key >= 48 &&
      key <= 57) ||
    // Numeric keypad
    // Backspace and Tab and Enter
    key === 8 ||
    key === 9 ||
    key === 13 ||
    // Home and End
    key === 35 ||
    key === 36 ||
    // left and right arrows
    key === 37 ||
    key === 39 ||
    // Del and Ins
    key === 46 ||
    key === 45
  ) {
    // input is VALID
  } else {
    // input is INVALID
    e.returnValue = false;
    if (e.preventDefault) e.preventDefault();
  }
};

type Props = {
  control: Control;
  register: (ref, registerOptions?) => { onChange; onBlur; name; ref };
  name: string;
  maxLength: number;
  nextField: string;
  placeholder: string;
  setFocus: (field: string) => void;
};

export const DOBField = ({
  control,
  name,
  register,
  // setFocus,
  maxLength,
  nextField,
  placeholder,
  ...props
}: Props) => {
  const { t } = useTranslation("common");
  return (
    <Flex flexDirection="column" gap="4px">
      <OFText textStyle="subhead1" color={colors.grey[900]}>
        {t(`common:DOB_input.${name}_field_name`)}
      </OFText>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          return (
            <OFInput
              fontSize="16px"
              onKeyPress={validate}
              ref={field.ref}
              maxLength={maxLength}
              placeholder={t(`common:${placeholder}`)}
              {...register(name)}
              onChange={(e) => {
                field.onChange(e);
                if (e?.target?.value?.length === maxLength && nextField) {
                  // setFocus(nextField);
                }
              }}
              value={field.value}
              {...props}
            />
          );
        }}
      />
    </Flex>
  );
};
